export const SCROLLBAR_HIDE =
  '[-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden';

export const darkCardRoot =
  'dark:bg-gray-dark-900 dark:border-gray-dark-600 bg-gray-dark-900 border-gray-dark-600';
